import { Link, type LinkProps } from "react-router-dom";
import { trackCtaClick } from "../lib/analytics";
import { useI18n } from "../i18n";

type Props = LinkProps & { cta: string; block?: string };

export function CtaLink({ cta, block, onClick, children, ...rest }: Props) {
  const { lang } = useI18n();
  return (
    <Link
      {...rest}
      onClick={(e) => {
        trackCtaClick(cta, block, lang);
        onClick?.(e);
      }}
    >
      {children}
    </Link>
  );
}
